import React from 'react';
import 'react-toastify/dist/ReactToastify.css';
import './Layout.css';
import ErrorBoundary from '../../../ErrorBoundary';

const Layout = ({ children }) => {
    return (
        <ErrorBoundary>
            <div className='content-layout layout-bg'>
                <div className='col-12'>{children}</div>
            </div>
        </ErrorBoundary>
    );
};

export default Layout;
